import { Component, Inject, OnInit, Renderer2, } from '@angular/core';
import { AccountsService } from '../services/account.service';
import { DOCUMENT } from '@angular/common';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  // title = '';
  // @ViewChild(MatSidenav) sidenav!: MatSidenav;

  // isSidenavOpen = false; 
  // isMobile= false;  
  // isLoggedIn=false;
  // currentTheme?='';
  // userName='';
  

 constructor(
      private accountService: AccountsService,
      private themeService: ThemeService,
      @Inject(DOCUMENT) private document: Document,
      private renderer: Renderer2) {}

  ngOnInit() {
    this.themeService.loadSavedTheme();
  }

}
